import { Paper, Table, TableContainer } from '@mui/material';

export default function GridContent({ children }: any) {
    return (
        <TableContainer component={Paper} elevation={0}>
            <Table size="small">{children}</Table>
        </TableContainer>
    );
}